<template>
    <kgr-input-group
        :label="label"
        :tooltip="tooltip"
        :required="required"
        :inline="inline"
        :error-message="error.messageForField(fieldName)"
    >
        <slot></slot>
    </kgr-input-group>
</template>

<script>
import Error from '../../../js/model/Error';
import InputGroup from './InputGroup';

export default {
    components: {
        'kgr-input-group': InputGroup,
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        fieldName: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            required: false,
        },
        error: {
            type: Error,
            required: true,
        },
        required: {
            type: Boolean,
            required: false,
        },
        inline: {
            type: Boolean,
            required: false,
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
